import React from "react"

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string } from "prop-types"

function DetailRows({ rows }) {
  return (
    <div className="model-details-card__rows">
      {rows.map(({ label, value, tag }) => (
        <div className="model-details-card__row" key={label}>
          <p className="model-details-card__label cgt-overline-sm">{label}</p>
          <p
            className={classnames(
              'model-details-card__value',
              'cgt-caption-semibold',
              tag && 'model-details-card__value--with-tag',
            )}
          >
            {value}
            {/* Explicit space so the value and tag are separate words to a screen
                reader, rather than relying on the flex gap or on the browser's
                text-alternative rules for non-inline boundaries. */}
            {tag && <>{' '}<span className="model-details-card__tag cgt-overline-sm">{tag}</span></>}
          </p>
        </div>
      ))}
    </div>
  )
}

DetailRows.propTypes = {
  rows: arrayOf(shape({ label: string.isRequired, value: string.isRequired, tag: string })).isRequired,
}

export default DetailRows
